import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { resetForm } from 'State/forms/actions';
import { Filter, Main } from 'Containers';
import { errorToast } from 'Common/ToastHelper';
import { TRUCK_ROUTE_REPORT_FORM_NAME } from 'Common/FormEnum';
import { TruckRouteReportEnum } from 'Common/FieldEnum';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { ReportGeneration } from 'Common/ObjectHelper';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';

import {
  printReportData,
  clearPrintReportError,
} from './../../commonState/actions';
import TruckRouteReportComponent from './../components/TruckRouteReport';
import * as CommonPrintSelector from '../../commonState/selectors';
import { GroupByOptionsEnum } from './../helper/index';

class TruckRouteReportContainer extends Component {
  static propTypes = {
    resetForm: PropTypes.func.isRequired,
    printReportData: PropTypes.func.isRequired,
    clearPrintReportError: PropTypes.func.isRequired,
    printLoading: PropTypes.bool.isRequired,
    initialValues: PropTypes.object.isRequired,
    groupByOptionsValue: PropTypes.number,
    printError: PropTypes.object,
    printData: PropTypes.string,
  };

  static defaultProps = {
    groupByOptionsValue: 0,
    printError: null,
    printData: '',
  };
  reactTableRef = React.createRef();
  state = {
    selectedGroupOption: GroupByOptionsEnum.SITE,
    selectedSites: [],
    allSites: [],
    activeIndexForFilter: 0,
  };

  componentWillUnmount() {
    toast.dismiss();
  }

  getMainProps = () => {
    const { printLoading } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Print',
            onClick: this.printReport,
            disabled: printLoading,
            loading: printLoading,
          },
        ],
        shown: true,
      },
    };
  };

  printReport = () => {
    const { selectedSites, allSites, selectedGroupOption } = this.state;
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: allSites };
    let sites = [];
    _.forEach(dataObjs.sortedData, obj => {
      if (obj._subRows) {
        const subRowSites = _.filter(
          obj._subRows,
          subObj => selectedSites.indexOf(subObj.Id) !== -1
        ).map(v => v.Id);
        sites = [...sites, ...subRowSites];
      } else {
        const id = obj.Id ? obj.Id : obj._original.Id;
        if (selectedSites.indexOf(id) !== -1) {
          sites.push(id);
        }
      }
    });
    if (sites.length) {
      const printObject = {
        SiteIds: sites,
        GroupBy: selectedGroupOption,
        SearchByDay: this.props.selectedDays,
      };
      this.props.printReportData('TruckRoute/GetTruckRouteReport', printObject);
    } else {
      this.props.setNotificationDialog(
        NOTIFICATION_DIALOG_MESSAGES.TRUCK_ROUTE_REPORT_SITE_SELECTION_VALIDATION
      );
    }
  };

  setSelectedSites = selectedSites => {
    this.setState({ selectedSites: selectedSites });
  };

  componentDidUpdate(prevProps) {
    const { clearPrintReportError, printData } = this.props;
    if (errorToast(this.props, prevProps, 'printError')) {
      this.props.clearPrintReportError();
    }
    if (printData && printData !== prevProps.printData) {
      ReportGeneration(printData, 'Truck Route Report');
      clearPrintReportError();
    }
  }

  setGroupByOption = value => {
    this.setState({
      selectedGroupOption: value,
    });
  };

  clearFilters = () => {
    this.setState({
      selectedGroupOption: GroupByOptionsEnum.SITE,
    });
    this.completeReset();
  };

  completeReset = () => {
    this.props.resetForm(TRUCK_ROUTE_REPORT_FORM_NAME);
  };

  getSitesCallback = allSites => {
    this.setState({ allSites });
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexForFilter } = this.state;
    const newIndex = activeIndexForFilter === index ? -1 : index;
    this.setState({
      activeIndexForFilter: newIndex,
    });
  };

  render() {
    const { groupByOptionsValue } = this.props;
    return (
      <Fragment>
        <Filter title={'Reports | Truck Route'} />
        <Main {...this.getMainProps()} shouldNotUsePageWidth>
          <TruckRouteReportComponent
            setGroupByOption={this.setGroupByOption}
            groupByOptionsValue={groupByOptionsValue}
            clearFilters={this.clearFilters}
            setSelectedSites={this.setSelectedSites}
            getSitesCallback={this.getSitesCallback}
            activeIndexForFilter={this.state.activeIndexForFilter}
            handleClick={this.handleClick}
            reactTableRef={this.reactTableRef}
          />
        </Main>
      </Fragment>
    );
  }
}
const selector = formValueSelector(TRUCK_ROUTE_REPORT_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(TRUCK_ROUTE_REPORT_FORM_NAME)(state));

  return {
    initialValues: {
      [TruckRouteReportEnum.GroupByOptions]: GroupByOptionsEnum.SITE,
      [TruckRouteReportEnum.DayOfWeek]: [],
    },
    groupByOptionsValue: selector(state, TruckRouteReportEnum.GroupByOptions),
    selectedDays: selector(state, TruckRouteReportEnum.DayOfWeek),
    printLoading: CommonPrintSelector.getPrintLoading(state),
    printError: CommonPrintSelector.getPrintError(state),
    printData: CommonPrintSelector.getPrintData(state),
  };
};

const mapDispatchToProps = {
  resetForm,
  printReportData,
  clearPrintReportError,
  setNotificationDialog,
};

TruckRouteReportContainer = reduxForm({
  destroyOnUnmount: false,
  form: TRUCK_ROUTE_REPORT_FORM_NAME,
})(TruckRouteReportContainer);

export const TruckRouteReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(TruckRouteReportContainer);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/truckroutereport/containers/TruckRouteReport.js